import { ColoredCircle } from "../../utils/styles";

const DotBadge = ({ color }) => {
    return ( <>
        <ColoredCircle style={{ backgroundColor: color }} />
    </> );
}
 
export default DotBadge;